import { render, staticRenderFns } from "./EmployerSector.vue?vue&type=template&id=347b9bb9"
import script from "./EmployerSector.vue?vue&type=script&lang=js"
export * from "./EmployerSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports